module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tab-panel padded text-center"
  }, [_c('chart', {
    attrs: {
      "includeTotals": true,
      "path": "/api/people/GetChartSales"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48ab0c46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/extras/ExtraOverview.vue
// module id = 1418
// module chunks = 0